import React from 'react';
import Select from 'react-select';
import i18next from '../../i18n.js';

const SelectInput = (props) => {
    const { name, value, values, canSearch, hasEmptyValue, disabled, placeholder } = props;

    const selectOptions = values?.data?.filter(item => !item.hidden);

    return canSearch ? (<div className='select_input-control'>
        <input name={name} style={{ width: "0", height: "0", border: "none", opacity: "0", position: "absolute" }} />
        <Select
            options={selectOptions}
            isLoading={!values?.data}
            placeholder={disabled ? '' : (placeholder ?? i18next.t('form.fields.selectSearchPlaceholder'))}
            noOptionsMessage={() => i18next.t('form.fields.selectSearchNoResults')}
            loadingMessage={() => i18next.t('loading')}
            isClearable={true}
            classNamePrefix={'select_input'}
            onChange={(selected) => {
                if (props.onChange) props.onChange({
                    target: {
                        name: name,
                        value: selected?.value
                    }
                });
            }}
            value={selectOptions.find(opt => opt.value === value)}
            isDisabled={disabled}
            menuPortalTarget={document.body}
            menuPosition='fixed'
            menuPlacement='auto'
        />
    </div>) :
        (<select name={name} className="form-control" value={value} onChange={props.onChange} disabled={disabled ? "disabled" : ""}>
            {hasEmptyValue && <option key="empty" value="">{placeholder ?? i18next.t('other.selectFieldEmptyLabel')}</option>}
            {values?.data?.map(item =>
                <option key={item.value} value={item.value} style={{ display: item.hidden ? "none" : "" }}> {item.label}</option>
            )}
        </select>);
}

export default SelectInput;
